import styled from '../../styled';
import fromTheme from '../../fromTheme';

const MenuDivider = styled('li').attrs({ name: 'menu-divider', role: 'separator' })`
    height: 1px;
    margin: ${fromTheme('menu', 'divider', 'margin')};
    background-color: ${fromTheme('menu', 'divider', 'color')};
`;
MenuDivider.displayName = 'MenuDivider';
MenuDivider._reactMenu = 'MenuDivider';

export default MenuDivider;
